// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8aa89ac1","570":"3c39b72b","625":"4f0a55c6"}[chunkId] + ".chunk.js";
};